import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from '../Icon'
import { isFunction } from '../../utils/inference'
import './index.scss'
/**
 * 列表
 */

interface ItemProps {
    extra?: React.ReactNode // 列表项右侧区域
    description?: React.ReactNode // 列表项中间下部的描述区域
    prefix?: React.ReactNode // 列表项左侧区域
    arrow?: boolean | React.ReactNode // 右侧是否显示箭头图标，也支持传入 ReactNode 来自定义图标
    disabled?: boolean // 是否禁用
    style?: any 
    justify?: 'flex-start' | 'flex-end'
    onClick?: (values) => void // 列表项的点击事件，当设置了 onClick 属性时，列表项会有点击效果
}
export const Item: React.FC<ItemProps> = props => {
    
    // 点击某一项
    const handleClick = () => {
        if(props.disabled) {
            // 禁用
            return
        }
        if(isFunction(props.onClick)) {
            props.onClick(props)
        }
    }

    return (
        <div className='mume-item' style={props?.style || {}} onClick={handleClick}>
            <div className='mume-item-label'>{props.children}</div>
            <div className={`mume-item-extra ${props.justify || ''}`}>{props.extra}</div>
            {!!props.arrow && !props.disabled &&  <div className='mume-item-arrow'>
                {typeof(props.arrow) === 'boolean' ? <Icon icon='&#xe70b;' /> : props.arrow}
            </div>}
        </div>
    )
}

interface ListProps {
    style?: React.CSSProperties
    header?: React.ReactNode // 标题
    mode?: 'default' | 'card' // 支持默认和卡片两种模式
}
const List: (React.FC<ListProps> | any) = props => {

    return (
        <div className='mume-list' style={props.style || {}}>
            {props.children}
        </div>
    )
}

List.Item = Item

export default List